// extracted by mini-css-extract-plugin
export default {"caseLayoutRoot":"CaseLayout_caseLayoutRoot__u-EHI","floating":"CaseLayout_floating__2x6-4"};